export const calculatePercentage = (value: number, total: number) => {
  if (!value || !total) return 0

  return Math.round((value / total) * 10000) / 100
}
